export const IMAGE_PREVIEW_PLACEHOLDER_VARIANTS = {
  image: "PNG, JPG, GIF, SVG (max 5 MB)",
  account_image: (
    <span>
      PNG, JPG, GIF, SVG (max 5 MB)
      <br />
      Min width: 200 px
    </span>
  ),
};

export const IMAGE_PREVIEW_HEADER_PLACEHOLDER_VARIANTS = {
  default: "No Thumbnail",
  image: "Upload Image",
};
